<template>
  <div :class="scrollable ? 'max-h-96 overflow-y-auto' : ''">
    <div :class="[!inline ? 'rounded-lg bg-neutral-50 py-6 px-8' : '']">
      <pre
        class="text-xs text-neutral-400"
        :class="[inline ? 'overflow-hidden text-ellipsis whitespace-nowrap' : '']"
        v-html="addJsonFormatting(prettyPrint())"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  payload: string;
  format?: boolean;
  inline?: boolean;
  scrollable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  payload: '',
  format: true,
  scrollable: true
});

function prettyPrint(): string {
  if (props.format) {
    return JSON.stringify(JSON.parse(props.payload), null, 2);
  } else return props.payload;
}

/**
 * Adds HTML tags to the given JSON String.
 *
 * These tags will allow you to style segments of the JSON String:
 *  1. Class 'json-key' for all keys.
 *  2. Class 'json-string' for plain non-key strings.
 *  3. Class 'json-boolean' for boolean values.
 *  4. Class 'json-null' for null values.
 *  5. Class 'json-number' for number values.
 *
 * @param json the input json string
 * @returns {*} the formatted input
 */
function addJsonFormatting(json: string) {
  const regex =
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g; // eslint-disable-line no-useless-escape
  const sanitizedJson = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return sanitizedJson.replace(regex, function (match) {
    let cls = 'text-[#60a9a5]';
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'text-neutral-600';
      } else {
        cls = 'text-primary-500';
      }
    } else if (/true|false/.test(match)) {
      cls = 'text-[#8865ce]';
    } else if (/null/.test(match)) {
      cls = 'text-[#8865ce]';
    }
    return `<span class="${cls}">${match}</span>`;
  });
}
</script>
